import { BlocksIconZoomIn } from 'blocks-nextjs/blocks-web-components/components/icon/icons/zoom-in';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconZoomIn = createComponent({ react: React, tagName: 'cat-icon-zoom-in', elementClass: BlocksIconZoomIn });
